/**
 * Created by lu on 2018/4/3.
 */
var nb = require('../../nb');
module.exports = nb.define({
    view:{
        tag:'li',
        'class':'search-menuitem',
        $html:[{
            tag:'span',
            $html:nb.bind('text')
        }]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/header/KeywordItem.js
// module id = 45
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32